import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { AppService } from "src/_services/app.service";
import { changePassword } from "src/_models/index";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./change-password-dialog.component.html",
  styleUrls: ["./change-password-dialog.component.scss"],
})
export class ChangePasswordModalComponent {
  private user: changePassword;
  page: "";
  hide = false;
  hide1 = false;
  modalData: any;
  changePwdForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private appService: AppService,
    private formBuilder: FormBuilder
  ) {
    this.modalData = data;
    this.page = data.page;
  }

  ngOnInit() {
    this.changePwdForm = this.formBuilder.group({
      userId: [this.modalData.userId, Validators.required],
      operatorId: ["", Validators.required],
      password: ["", Validators.required],
      oldPassword: ["", Validators],
      newPassword: ["", Validators],
    });
  }

  get formControls() {
    return this.changePwdForm.controls;
  }

  get isValid() {
    if((this.formControls["userId"].value !== "" && this.formControls["operatorId"].value !== "" &&
       this.formControls["newPassword"].value !== "") || (this.formControls["userId"].value !== "" &&
       this.formControls["oldPassword"].value !== "" && this.formControls["newPassword"].value !== ""))
       {
          return false;
       }
      return true;
      }

  onFormSubmit() {
    const postBody = {
      userId: this.modalData.userId,
      operatorId: this.formControls["operatorId"].value,
      newPassword: this.formControls["newPassword"].value,
      oldPassword: this.formControls["oldPassword"].value,
    };

    if (postBody.oldPassword) {
      try {
        this.appService.changePassword(postBody).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.dialogRef.close();
            this.appService.openSuccessBar("Password changed successfully.");
            this.router.navigateByUrl("/login");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) {
        console.log("err", err);
      }
    } else {
      try {
        this.appService.resetUserPassword(postBody).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.dialogRef.close();
            this.appService.openSuccessBar("Password changed successfully.");
            // this.router.navigateByUrl("/login");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) {
        console.log("err", err);
      }
    }
  }
}
